module.exports = __webpack_public_path__ + "static/media/MUSEAbadge-black.13bf9541.jpg";